/**
 * ContactButton - "Get in Touch" button that opens Intercom
 */

interface ContactButtonProps {
  /** Callback when button is clicked (e.g., open Intercom) */
  onClick?: () => void;
}

export function ContactButton({ onClick }: ContactButtonProps) {
  const handleClick = () => {
    // Try to open Intercom if available
    if (typeof window !== 'undefined' && (window as unknown as { Intercom?: (action: string) => void }).Intercom) {
      (window as unknown as { Intercom: (action: string) => void }).Intercom('show');
    }
    onClick?.();
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <p className="text-base font-bold text-slate-900">Still have questions?</p>
      <button
        type="button"
        onClick={handleClick}
        className="inline-flex items-center justify-center min-h-[44px] rounded-full bg-[#183344] text-sm font-bold text-white tracking-wide transition-colors hover:bg-[#1a3d4f]"
        style={{ padding: '10px 32px' }}
      >
        Get in Touch
      </button>
    </div>
  );
}

export default ContactButton;
